// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__2a43p","Label":"Input_Label__c5RGj","InputElement":"Input_InputElement__3UST0","Invalid":"Input_Invalid__1Q37g"};